import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import InfiniteScroll from 'redux-infinite-scroll-sf'

import Quests from '../components/Quests'
import QuestsSearch from '../components/mini/QuestsSearch'
import QuestsSearchResultsCount from '../components/mini/QuestsSearchResultsCount'
import DesignANewQuest from '../components/mini/DesignANewQuest'
import HeaderLockup from '../components/mini/HeaderLockup'
import OrgAvatar from '../components/mini/OrgAvatar'
import NoQuestsMatchYourSearch from '../components/mini/NoQuestsMatchYourSearch'

import { requestUserData } from '../actions/user'
import { fetchQuests } from '../actions/quests'
import { currentOrg } from '../selectors/organization'
import { isQuestDesignerOrIsQuestManager } from '../utils/user'

class QuestsContainer extends Component {
  constructor(props) {
    super(props)
    this.loadMoreQuestsBound = this.loadMoreQuests.bind(this)
    this.addQuestBound = this.addQuest.bind(this)
  }

  componentDidMount() {
    this.props.dispatch(fetchQuests(1, true))
    this.props.dispatch(requestUserData())
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentOrg !== this.props.currentOrg) {
      this.props.dispatch(fetchQuests(1, true))
    }
  }

  render() {
    const {
      quests,
      isFetchingQuests,
      totalQuests,
      currentOrg,
      user,
      dispatch
    } = this.props

    return (
      <div className="quests-container">
        <React.Fragment>
          <HeaderLockup
            avatarComponent={<OrgAvatar organization={currentOrg} />}
            organization={currentOrg}
            section="All Quests"
          />
          {isQuestDesignerOrIsQuestManager(user) && (
            <DesignANewQuest addQuest={this.addQuestBound} />
          )}
        </React.Fragment>
        <div className="quests-search-quests-list-container">
          <QuestsSearch />
          <div className="count-and-list-container">
            {!isFetchingQuests && totalQuests > 0 && (
              <QuestsSearchResultsCount totalQuests={totalQuests} />
            )}
            {!isFetchingQuests && totalQuests === 0 && (
              <NoQuestsMatchYourSearch text="No quests match your search." />
            )}
            {isFetchingQuests && <div className="loading" />}
            {quests && quests.length > 0 && (
              <div id="quest-list">
                <InfiniteScroll
                  items={
                    <Quests
                      quests={quests}
                      dispatch={dispatch}
                      user={user}
                      iconHeightWidth={82}
                    />
                  }
                  loadMore={this.loadMoreQuestsBound}
                  loadingMore={isFetchingQuests}
                  elementIsScrollable={false}
                  showLoader={false}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  loadMoreQuests() {
    // Only load more quests if the size of the quest list is less than the totalquest count from the search call
    if (this.props.quests.length < this.props.totalQuests) {
      this.props.dispatch(fetchQuests(this.props.page + 1, false))
    }
  }

  addQuest() {
    this.props.dispatch(push('/quests/add'))
  }
}

QuestsContainer.propTypes = {
  quests: PropTypes.array,
  page: PropTypes.number,
  isFetchingQuests: PropTypes.bool,
  currentOrg: PropTypes.object,
  totalQuests: PropTypes.number,
  dispatch: PropTypes.func,
  user: PropTypes.object
}

export const mapStateToProps = state => ({
  quests: state.quests.items,
  page: state.quests.page,
  isFetchingQuests: state.quests.isFetching,
  currentOrg: currentOrg(state),
  totalQuests: state.quests.total,
  user: state.user.user
})

export default connect(mapStateToProps)(QuestsContainer)
export { QuestsContainer as QuestsDisconnected }



// WEBPACK FOOTER //
// ./src/containers/Quests.js